import log from 'salvo-lite/log'

class Video {
    constructor (theme, elem) {
        this._theme = theme
        this._wrapper = elem
        this._data = {
            playWhenPartiallyLoaded: false,
            playWhenFullyLoaded: false,
            ...JSON.parse(elem.getAttribute('data-video') || '{}')
        }
        this._video = elem.querySelector('[data-video-video]') || elem
        this._videoMobile = elem.querySelector('[data-video-mobile]') || elem
        this._playBtn = elem.querySelector('[data-video-play]')
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        if (this._data.playWhenPartiallyLoaded && this._videoIsPartiallyLoaded) this._playVideo()
        if (this._data.playWhenFullyLoaded && this._videoIsFullyLoaded) this._playVideo()

        if (this._playBtn) {
            this._playBtn.addEventListener('click', () => this._playVideo())
            this._video.addEventListener('click', () => !this._video.paused && this._pauseVideo())
            this._videoMobile.addEventListener('click', () => !this._videoMobile.paused && this._pauseVideo())
            if (window.innerWidth <= 480) {
                this._wrapper.addEventListener('click', () => !this._video.paused ? this._pauseVideo : this._playVideo())
                this._wrapper.addEventListener('click', () => !this._videoMobile.paused ? this._pauseVideo : this._playVideo())
            }
        } else {
            this._video.addEventListener('click', () => !this._video.paused ? this._pauseVideo() : this._playVideo())
            this._videoMobile.addEventListener('click', () => !this._videoMobile.paused ? this._pauseVideo() : this._playVideo())
        }
    }

    _videoIsPartiallyLoaded () {
        this._video.addEventListener('canplay', () => true)
        this._videoMobile.addEventListener('canplay', () => true)
    }
    _videoIsFullyLoaded () {
        this._video.addEventListener('canplaythrough', () => true)
        this._videoMobile.addEventListener('canplaythrough', () => true)
    }

    _playVideo () {
        this._videoMobile.play()
        this._video.play()
        this._wrapper.classList.add('video--playing')
    }

    _pauseVideo () {
        this._videoMobile.pause()
        this._video.pause()
        this._wrapper.classList.remove('video--playing')
    }
}

export default Video



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Video.js